var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfirm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.6347 24.9183C53.7486 26.0322 53.7486 27.8378 52.6347 28.9512L33.5047 48.0817C32.3909 49.195 30.5858 49.195 29.4719 48.0817L20.3653 38.9745C19.2514 37.8612 19.2514 36.0556 20.3653 34.9422C21.4786 33.8283 23.2842 33.8283 24.3976 34.9422L31.488 42.0327L48.6019 24.9183C49.7158 23.805 51.5214 23.805 52.6347 24.9183ZM73 36.5C73 56.6754 56.6726 73 36.5 73C16.3246 73 0 56.6726 0 36.5C0 16.3246 16.3274 0 36.5 0C56.6754 0 73 16.3274 73 36.5ZM67.2969 36.5C67.2969 19.477 53.5208 5.70312 36.5 5.70312C19.477 5.70312 5.70312 19.4792 5.70312 36.5C5.70312 53.523 19.4792 67.2969 36.5 67.2969C53.523 67.2969 67.2969 53.5208 67.2969 36.5Z",
    fill: "#4AAE8C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirm);
export default __webpack_public_path__ + "static/media/confirm.d0b85e02dedf2eed6c426d53b269d9bc.svg";
export { ForwardRef as ReactComponent };